import React, { FC, useCallback } from "react";
import {
  UserAttendance,
  AttendancePair,
} from "../../../../../../../domain/attendance/Attendance";
import { FixedSizeList as List } from "react-window";
import { AutoSizer, Size } from "react-virtualized";
import { AttendanceSearchRow } from "./row";
import { EmptyState } from "../../../../../../components/state/empty";
import { faList, faSearch } from "@fortawesome/free-solid-svg-icons";

export type AttendanceSearchListProps = {
  items: AttendancePair[] | null;
  onClick: (vehicle: AttendancePair, type: string) => void;
};

export type AttendanceSearchListRowProps = {
  items: AttendancePair[];
  onClick: React.MouseEventHandler<HTMLDivElement>;
};

export const AttendanceSearchListWindow: FC<AttendanceSearchListProps> = ({
  items,
  onClick,
}) => {
  /* eslint-disable */
  const onRowClick = useCallback<React.MouseEventHandler<HTMLDivElement>>(
    (e) => {
      if (!items) return;
      const index = e.currentTarget.dataset.index;
      if (index) {
        onClick(items[index as unknown as number], "Attendance");
      }
    },
    [items]
  );

  /* eslint-enable */

  return items === null ? (
    <EmptyState
      icon={faSearch}
      title={"Buscar Asistencia"}
      message={"Ingrese un término de búsqueda."}
    />
  ) : items.length > 0 ? (
    //@ts-ignore
    <AutoSizer>
      {(props: Size) => (
        <List
          height={props.height}
          itemCount={items?.length || 0}
          itemSize={200}
          width={props.width}
          itemData={{
            items,
            onClick: onRowClick,
          }}
        >
          {AttendanceSearchRow}
        </List>
      )}
    </AutoSizer>
  ) : (
    <EmptyState
      icon={faList}
      title={"Sin resultados"}
      message={`No hay asistencias que coincidan con la búsqueda.`}
    />
  );
};
